import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_SCHEME_GATEWAY}://${
    import.meta.env.VITE_URL_GATEWAY
  }`,
  withCredentials: true,
});
